module.exports = __webpack_public_path__ + "static/img/yx3.8ad653a8.png";